import React from 'react';
import Config from '../../config/Config';

const LoadingPaymentModel = () => {
	const el = document.getElementsByClassName('download-app');
	if (!!el && !!el[0]) {
		el[0].style.display = 'none';
	}
	return (
		<div>
			<div className="col-lg-12 text-center error-page">
				<div className="loader">Loading...</div>
				<p className="paytm-redirect">
					Please wait while we take you to the payment gateway....
				</p>
				<p className="close-redirect">
					Please do not close or leave this page until the payment is completed.
					<br />
					You will be redirected back to the STEP application on completion of the
					payment.
				</p>
				<img
					src={Config.ASSETSPATH + 'img/payment_logo.png'}
					className="mt-5"
					alt="Logo"
				/>
			</div>
		</div>
	);
};
export default LoadingPaymentModel;
